import { render } from "./ApplyBatchConfigTemplate.vue?vue&type=template&id=38572b33"
import script from "./ApplyBatchConfigTemplate.vue?vue&type=script&lang=js"
export * from "./ApplyBatchConfigTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__